import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	OnDestroy,
	OnInit,
	ViewChild,
} from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { tap } from 'rxjs/operators';

import { Subscription, zip } from 'rxjs';

import { LoaderComponent } from 'ib/internetbank-core/ib-components/loader/loader.component';

import { AuthorizationService } from '../../../authorization/authorization.service';
import { ExternalSystemsConfigService } from '../../../common/services/external-systems-config.service';


@Component({
	selector: 'app-credit-history',
	templateUrl: './credit-history.component.html',
	styleUrls: ['./credit-history.component.less'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class CreditHistoryComponent implements OnInit, OnDestroy {

	@ViewChild(LoaderComponent, { static: true })
	public loader: LoaderComponent;
	public clientCreditBureauToken: string;
	public clientCreditBureauUrl: SafeResourceUrl;


	private defaultUrl: string = ExternalSystemsConfigService.creditHistoryFrameSrc;
	private subscriptions: Subscription = new Subscription();

	constructor(
		private authorizationService: AuthorizationService,
		private sanitizer: DomSanitizer,
		private changeDetectorRef: ChangeDetectorRef,
	) {
		this.clientCreditBureauUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
			this.defaultUrl,
		);
	}

	public ngOnInit(): void {
		this.loader.show();

		this.subscriptions.add(
			zip(
				this.authorizationService.clientCreditBureauToken$,
				this.authorizationService.getCreditBureauUrl(),
			)
				.pipe(
					tap((data: Array<string>) => {
						if (data[0]) {
							this.clientCreditBureauToken = data[0];
							setTimeout(this.submitForm, 10);
						}
						this.clientCreditBureauUrl = this.sanitizer.bypassSecurityTrustResourceUrl(data[1] || this.defaultUrl);
						this.loader.hide();
					}),
					tap(() => {
						this.changeDetectorRef.markForCheck();
					}),
				)
				.subscribe());
	}

	public ngOnDestroy(): void {
		this.subscriptions.unsubscribe();
	}

	private submitForm(): void {
		const form: HTMLElement | null = document.getElementById('creditBureauForm');
		if (form) {
			form['submit']();
			form.remove();
		}
	}
}
